module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/hiroos/hiroos.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/hiroos/hiroos.png
// module id = 573
// module chunks = 0